import { yodaBudgetConstants } from "../constants";
import { yodaBudgetService } from "../services";
import { yodaUtilsActions } from "./yodaUtils.actions";

export const yodaBudgetActions = {
  getBudget,
};

function getBudget(customerId, seasonCode, lineCode) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaBudgetService.getBudget(customerId, seasonCode, lineCode).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaBudgetService.getBudget",
      { customerId, seasonCode, lineCode },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaBudgetConstants.GETBUDGET_REQUEST };
  }
  function success(budget) {
    return { type: yodaBudgetConstants.GETBUDGET_SUCCESS, payload: { budget } };
  }
  function failure(error) {
    return { type: yodaBudgetConstants.GETBUDGET_FAILURE, payload: { error } };
  }
}
